export const commonRoutes = {
  FORBIDDEN: "/forbidden",
  SERVER_ERROR: "/server-error",
  NETWORK_ERROR: "/network-error",
  PAGE_NOT_FOUND: "/page-not-found",
  FORGET_PASSWORD: "/forget-password",
  FORGET_PASSWORD_OTP: "/forget-password-otp",
  RESET_PASSWORD: "/reset-password",
};
